// extracted by mini-css-extract-plugin
export default {"privacy":"index_privacy_RsEHu"};